import { Pipe, PipeTransform } from '@angular/core'

import dayjs from 'dayjs'

import { dateFormats } from '@app/core/constants/dateFormats'
import { AuthService } from '@app/modules/auth/auth.service'

@Pipe({
  name: 'dayjsDaysBetweenDates',
  standalone: false,
})
export class DayjsDaysBetweenDatesPipe implements PipeTransform {
  constructor(private readonly authService: AuthService) {}

  transform(start?: string, end?: string): number {
    const dateFormat = this.authService.getCurrentUserDateFormat() || dateFormats.date

    const transformedStart = dayjs(start, dateFormat)
    const transformedEnd = dayjs(end, dateFormat)

    return dayjs.duration(transformedStart.diff(transformedEnd)).asDays()
  }
}
